<style scoped>
    .vs-table--tbody-table .tr-values td {
        padding: 3px;
    }
</style>

<template>
<div>
	<div class="vx-col w-full mb-base">
		<vs-card class="p-4 mb-6">
         <div slot="header" class="flex flex-wrap items-center justify-between">
            <div class="flex items-center">
                <vs-button radius color="primary" icon="keyboard_backspace" @click="cancelAndBack()"></vs-button>
                <h4 class="ml-5">View  Good Receive</h4>
            </div>
            <div class="flex items-center" >
            <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="on_edit = true" v-show="!on_edit" icon="edit">Edit</vs-button>
            <vs-dropdown vs-trigger-click class="mr-1" v-show="!on_edit">
                <vs-button class="btn-drop" type="filled" icon="apps">Proccess</vs-button>
                <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemCheck">
                    Item Check
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="exportFileItemCheck">
                    Checking Report
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="postGoodReceive">
                        Good Receive
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="cancelGoodReceive">
                        Cancel GR
                    </vs-dropdown-item>
                    <vs-dropdown-group vs-collapse vs-label="Movement Order" vs-icon="add">
                        <vs-dropdown-item @click="putAwayBackground">
                            Putaway Background
                        </vs-dropdown-item>
                        <vs-dropdown-item  @click="putAwayForeground">
                            Putaway Foreground
                        </vs-dropdown-item>
                        <vs-dropdown-item divider @click="viewPutaway('inbound/goodreceive/report/putawaylist/printpdf/')">
                            Print Putaway List
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="viewPutaway('inbound/goodreceive/report/putawaylist/printlabel/')">
                            Print Putaway Label
                        </vs-dropdown-item>
                        <vs-dropdown-item divider @click="reversePutaway">
                            Reverse Putaway
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="reversePutawayList">
                            Print Reverse Putaway List
                        </vs-dropdown-item>
                        <vs-dropdown-item divider @click="viewMo">
                            View Movement Orders
                        </vs-dropdown-item>
                    </vs-dropdown-group>
                </vs-dropdown-menu>
            </vs-dropdown>
            <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="updateGoodReceive" v-show="on_edit" :disabled="inboundItems.length <= 0" icon="save">Update</vs-button>
            <!-- <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="exportFile">Print</vs-button> -->
            <vs-dropdown vs-trigger-click>
                <vs-button class="btn-drop" type="filled" icon="print" v-show="!on_edit">Print</vs-button>
                <!-- <a href="#">Hola mundo</a> -->

                <vs-dropdown-menu>
                    <vs-dropdown-item  @click="printCheckingList">
                    Checking List
                </vs-dropdown-item>
                <vs-dropdown-item  @click="exportFileItemLabel">
                    Item Label
                </vs-dropdown-item>
                <vs-dropdown-item @click="exportFileGrNote">
                    GR Note
                </vs-dropdown-item>
                <vs-dropdown-item @click="printItemCheck">
                    GR Note Detail
                </vs-dropdown-item>
                <vs-dropdown-item @click="printGrLabel">
                    GR Note Label
                </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
            </div>
        </div>
		<div class="vx-row mt-6">
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						GR ID*
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="gr_id" disabled/>
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						GR Reference*
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="gr_reference"  :disabled="!on_edit || inbound_status.id != 4" />
					</div>
				</div>
				<div class="vx-row mb-3 mt-1">
					<div class="vx-col w-1/3">
						Arrival Date*
					</div>
					<div class="vx-col w-2/3">
						<flat-pickr class="w-full" v-model="arrival_date" :disabled="true" />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						GR Date*
					</div>
					<div class="vx-col w-2/3">
						<flat-pickr class="w-full" label="GR Date" v-model="gr_date" :disabled="true" />
					</div>
				</div>
			</div>
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Supplier ID*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="supplier_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, supplier)"
                            disabled
                        >
                            <vs-select-item v-for="(item, index) in supplier.data" :key="index" :value="item.id" :text="item.name"/>
                        </vs-select>
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						&nbsp;
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="supplier_address_1" disabled />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						&nbsp;
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="supplier_address_2" disabled />
					</div>
				</div>
			</div>
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Client ID*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="client_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, client)"
                            disabled
                        >
                            <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                        </vs-select>
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Inbound Reference*
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="inbound_reference"  :disabled="true" />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Order Type*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="order_type_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, order_type)"
                            disabled
                        >
                            <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                        </vs-select>
					</div>
				</div>
			</div>
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						GR Status
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="inbound_status.name" disabled />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						PO Date
					</div>
					<div class="vx-col w-2/3">
						<flat-pickr class="w-full" v-model="po_date" :disabled="!on_edit || inbound_status.id != 4" />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Warehouse*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="warehouse_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, warehouse)"
                            disabled
                        >
                            <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                        </vs-select>
					</div>
				</div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
						Attachment
					</div>
                    <div class="vx-col w-2/3">
                <input 
              type="file" 
              id="file_name"
              v-on:change="handleFileUpload($event)" :disabled="!on_edit"
            />
            </div>
        </div>
			</div>
		</div>
		<vs-tabs class="mt-10">
			<vs-tab label="Item Details">
				<vs-button class="btn mr-1 mt-5" @click="addItem()" :disabled="(client_id != null || !on_edit ) && inbound_status.id != 4 || !on_edit" type="border">Add</vs-button>
                <vs-button class="btn mr-1 mt-5" @click="removeItem()" :disabled="selected.length < 1" type="border">Remove</vs-button>
                <vs-table v-model="selected" :data="inboundItems" hoverFlat class="mt-5" multiple pagination max-items="20">
                    <template slot="thead">
                        <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                        <vs-th style="min-width: 70px; width: 70px">Inbound Line ID</vs-th>
                        <vs-th style="min-width: 200px;">Product ID</vs-th>
                        <vs-th style="min-width: 200px;">Description</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Stock Type</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Open Qty</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-show="tr.status != 'delete' ">
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.gr_line_id" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.line_id" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.product_id.id"
                                    width="100%"
                                    @input="setSelectedProduct(tr)" 
                                    autocomplete
                                    :disabled="true"
                                >
                                <vs-select-item v-for="(item, index) in productOption" :key="index" :value="item.id" :text="item.product_code"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.inbound_details.pack_id" :disabled="!on_edit || disabledFullyRecv(tr) || inbound_status.id != 4"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.inbound_details.batch" :disabled="!on_edit || disabledFullyRecv(tr) || inbound_status.id != 4"/>
                            </vs-td>
                            <vs-td>
                                <flat-pickr class="w-full" v-model="tr.inbound_details.expired_date" :disabled="!on_edit || inbound_status.id != 4"/>
                            </vs-td>
                            <vs-td>
                                <vs-input :danger="tr.err" val-icon-danger="clear" class="w-full" v-model="tr.qty" :disabled="tr.product_id.id == '' || !on_edit || disabledFullyRecv(tr) || inbound_status.id != 4" @input="Conversion(tr)"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.uom.id"
                                    width="100%"
                                    autocomplete
                                    :disabled="tr.qty <= 0 || !on_edit || disabledFullyRecv(tr) || inbound_status.id != 4"
                                    @input="onChangeUom(tr)"
                                    @change="Conversion(tr)"
                                >
                                <vs-select-item v-for="(item, index) in tr.uomOption" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.stock_type_id"
                                    width="100%"
                                    autocomplete
                                    :disabled="tr.qty <= 0 || !on_edit || disabledFullyRecv(tr)"
                                >
                                <vs-select-item v-for="(item, index) in stockTypeOption" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.open_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.base_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.base_uom.id"
                                    width="100%"
                                    autocomplete
                                    :disabled="true"
                                >
                                <vs-select-item v-for="(item, index) in tr.baseUomOption" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
			</vs-tab>
			<vs-tab label="Transport and Unloading">
				<div class="vx-row mt-6">
					<div class="vx-col md:w-1/4 w-full">
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
							<vs-input class="w-full" label="Checker" v-model="checker" :disabled="!on_edit" />
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
							<vs-input class="w-full" label="Supervisor" v-model="supervisor" :disabled="!on_edit" />
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
							<label for="" class="vs-input--label">Start Unloading</label>
							<flat-pickr class="w-full" v-model="start_unloading" :disabled="!on_edit" />
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
							<label for="" class="vs-input--label">End Unloading</label>
							<flat-pickr class="w-full" v-model="end_unloading" :disabled="!on_edit" />
							</div>
						</div>
					</div>
					<div class="vx-col md:w-1/4 w-full">
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
								<label for="" class="vs-input--label">Vehicle ID</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="vehicle_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, vehicle)"
                                    :disabled="!on_edit"
                                >
                                    <vs-select-item v-for="(item, index) in vehicle.data" :key="index" :value="item.id" :text="item.vehicle_code"/>
                                </vs-select>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
							<vs-input class="w-full" label="Driver" v-model="driver" :disabled="!on_edit" />
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
								<label for="" class="vs-input--label">Vehicle Type</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="vehicle_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, vehicle_type)"
                                    :disabled="!on_edit"
                                >
                                    <vs-select-item v-for="(item, index) in vehicle_type.data" :key="index" :value="item.id" :text="item.vehicle_type"/>
                                </vs-select>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
								<label for="" class="vs-input--label">Transporter</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="transporter"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, transporters)"
                                    :disabled="!on_edit"
                                >
                                    <vs-select-item v-for="(item, index) in transporters.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                                </vs-select>
							</div>
						</div>
					</div>
					<div class="vx-col md:w-1/4 w-full">
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
							<vs-input class="w-full mb-2" label="Container Number" v-model="container_number" :disabled="!on_edit" />
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
							<vs-input class="w-full mb-2" label="Seal Number" v-model="seal_number" :disabled="!on_edit" />
							</div>
						</div>
					</div>
				</div>
			</vs-tab>
			<vs-tab label="Notes">
				<vs-textarea height="200" class="mt-5" label="Notes" v-model="remark" :disabled="!on_edit || inbound_status.id != 4"/>
			</vs-tab>
			<vs-tab label="Attachment">
                        <vs-table :data="attachment">
                            <template slot="thead">
                                <vs-th>No.</vs-th>
                                <vs-th>File Name</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="indextr">
                                    {{ indextr + 1 }}
                                </vs-td>
                                <vs-td :data="data[indextr].file_name">
                                    {{ data[indextr].file_name }}
                                </vs-td>
                                <vs-td :data="indextr">
                                    <vs-button color="success" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Download</vs-button>
                                    <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Remove</vs-button>
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
            <vs-tab label="Operators">
                <label for="" class="vs-input--label">Operators</label>
                <vs-select
                    class="selectExample"
                    v-model="operators"
                    width="100%"
                    autocomplete
                    multiple
                    :disabled="!on_edit"
                >
                    <vs-select-item v-for="(item, index) in operatorData" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
			</vs-tab>
		</vs-tabs>
		</vs-card>
	</div>
    <vs-popup
    :active.sync="moModal"
    title="Movement Orders"
    fullscreen
	>
        <div class="flex flex-wrap items-center justify-end">
            <div class="flex items-center">
                <vs-button  @click="confirmData" class="btn mb-4 md:mb-0 mr-1" icon="check">Confirm</vs-button>
                <vs-button  @click="cancelData" class="btn mb-4 md:mb-0 mr-1" icon="cancel">Cancel</vs-button>
                <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list">Filter</vs-button>
            </div>
        </div>
        <ag-grid-vue
            :gridOptions="gridOptionsMo"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefsMo"
            :defaultColDef="defaultColDefMo"
            :rowData="moList"
            colResizeDefault="shift"
            :animateRows="false"
            :floatingFilter="false"
            :pagination="false"
            rowSelection="multiple"
            @selection-changed="onSelectionChangedMo"
            style="width: 100%"
        >
        </ag-grid-vue>
	</vs-popup>

	<vs-popup
    :active.sync="putawayModal"
    title="Print Putaway List"
	>
        <div class="flex flex-wrap items-center justify-end">
            <div class="flex items-center">
                <vs-button  @click="exportExel" class="btn mb-4 md:mb-0 mr-1" icon="print">Print</vs-button>
            </div>
        </div>
        <ag-grid-vue
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefsReport"
            :defaultColDef="defaultColDef"
            :rowData="moReportList"
            colResizeDefault="shift"
            :animateRows="false"
            :floatingFilter="false"
            rowSelection="single"
            @selection-changed="onSelectionChanged"
            style="width: 100%"
        >
        </ag-grid-vue>
	</vs-popup>

	<vs-popup title="Print Label" :active.sync="printLabelPopup">
		<vs-table :data="labelData" multiple stripe v-model="selectedLabel">
			<template slot="thead">
				<vs-th>Line ID</vs-th>
				<vs-th>Product</vs-th>
				<vs-th>UoM</vs-th>
				<vs-th>Label Qty</vs-th>
			</template>
			<template slot-scope="{data}">
				<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
					<vs-td>
						{{ tr.line_id }}
					</vs-td>
					<vs-td>
						{{ tr.product_code }}
					</vs-td>
					<vs-td>
						<vs-select
							class="selectExample"
							v-model="tr.uom_id"
							width="100%"
							@input="setLabelUom(tr)" 
							autocomplete
						>
						<vs-select-item v-for="(item, index) in tr.uoms" :key="index" :value="item.id" :text="item.name"/>
						</vs-select>
					</vs-td>
					<vs-td>
						{{ tr.qty }}
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
		<div class="flex flex-wrap items-center justify-between mt-5">
			<div class="flex items-center">
			</div>
			<div class="flex items-center">
				<vs-button class="mb-4 md:mb-0 mr-2" icon="delete" @click="removeLabel" color="danger">Remove</vs-button>
				<vs-button class="mb-4 md:mb-0" icon="print" @click="printLabel" color="success">Print Label</vs-button>
			</div>
		</div>
	</vs-popup>

 </div>
</template>

<script type="text/javascript">
	import vSelect from 'vue-select'
	import { AgGridVue } from "ag-grid-vue"
	// import InboundItem from '@/components/InboundItem.vue'
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';

	import '@/assets/scss/vuesax/_wmsTheme.scss';

	export default {
		name:"inb-create",
		components:{
			vSelect,
			flatPickr,
			// InboundItem,
			AgGridVue,
		},
		data(){
			return {
                attachment:[],
                operatorData: [],
                operators: [],
                selected: [],
					data_conv:0,
                    isLoading:false,
					gr_id:'',
					inbound_id:'',
					inbound_reference:'',
                    gr_reference:'',
					arrival_date:'',
					saveState:false,
					on_edit:false,

          old_open_qty:'',
          old_base_qty:'',
          old_qty:'',
                    gr_date:'',
					supplier_id:'',
					supplier_address_1:'',
					supplier_address_2:'',
					inbound_status:{},
					client_id:null,
					order_type_id:'',
					warehouse_id:'',
					po_date:'',
					remark:'',


					data:{
							line_id:'',
							product_id:'',
							descriptions:'',
							pack_id:'',
							batch:'',
							expired_date:'',
							uom_id:'',
							qty:'',
							base_uom:'',
							base_qty:'',
							open_qty:'',
							recv_qty:'',
					},

					// transport
					checker:'',
					supervisor:'',
					start_unloading:'',
					end_unloading:'',
					vehicle_id:null,
					driver:'',
					vehicle_type_id:null,
					transporter:null,
					container_number:'',
					seal_number:'',
					// end-transport

					input12:'',
                    select1:2,
                    options1:[
                        {text:'IT',value:0},
                        {text:'Blade Runner',value:2},
                        {text:'Thor Ragnarok',value:3},
                    ],
                    inboundItems:[],
                    oldInboundItems:[],
                    inboundItemsLength:0,
                    detailLength:0,

                    dataItemList:[],
                    clientDDL: null, 
                    clientOption: [],
                    warehouseDDL: null, 
                    warehouseOption: [],
                    orderTypeDDL: null, 
                    orderTypeOption: [],
                    supplierDDL: {}, 
                    supplierOption: [],

                    putawayPrintUrl:'',

                    //putawaylist
                    putawayModal:false,
                    putawayData:[],
                    moReportList:[],
                    columnDefsReport:null,
                    selectedIdReport:'',

                    // Table-config
                    moModal: false,
                    moData: [],
                    moList: [],
                    gridOptions: {},
                    gridOptionsMo: {},
                    gridApiMo:null,
                    maxPageNumbers: 7,
                    clients: [],
                    columnDefsMo: null,
                    defaultColDef: {
                        sortable: true,
                        resizable: true,
                        suppressMenu: true
                    },
                    defaultColDefMo: {
                        sortable: true,
                        resizable: true,
                        suppressMenu: true
                    },
                    productOption:[],
                    stockTypeOption:[], 
                    vehicleOption:[],
                    vehicleTypeOption:[],
					transporterOption:[],
					printLabelPopup: false,
					labelData: [],
                    selectedLabel: [],
                    supplier: {
                        data: [],
                        loading: false,
                        endpoint: 'master/customers',
                        objectKey: 'name'
                    },
                    client: {
                        data: [],
                        loading: false,
                        endpoint: 'master/clients',
                        objectKey: 'client_code'
                    },
                    order_type: {
                        data: [],
                        loading: false,
                        endpoint: 'master/ordertypes',
                        objectKey: 'order_type'
                    },
                    warehouse: {
                        data: [],
                        loading: false,
                        endpoint: 'master/warehouses',
                        objectKey: 'warehouses_code'
                    },
                    vehicle: {
                        data: [],
                        loading: false,
                        endpoint: 'master/vehicle',
                        objectKey: 'vehicle_code'
                    },
                    vehicle_type: {
                        data: [],
                        loading: false,
                        endpoint: 'master/vehicletypes',
                        objectKey: 'vehicle_type'
                    },
                    transporters: {
                        data: [],
                        loading: false,
                        endpoint: 'master/transporters',
                        objectKey: 'transporter_code'
                    }
			}
		},
	watch:{
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
	},
    beforeMount() {
        if(this.isLoading){
            this.$vs.loading()
        }
         this.columnDefsReport = [
                {
                    headerName: 'Movement ID',
                    field: 'movement_id',
                    width: 250,
                    hide: false,
                },
                {
                    headerName: 'Movement Date',
                    field: 'created_time',
                    width: 300,
                },
        ];

        this.columnDefsMo = [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 100,
                    hide: true,
                    // checkboxSelection: true,
                    // headerCheckboxSelectionFilteredOnly: true,
                    // headerCheckboxSelection: true,
                },
				{
                    headerName: 'Movement ID',
                    field: 'moh_id',
                    width: 100,
                    hide: false,
                    // checkboxSelection: true,
                    // headerCheckboxSelectionFilteredOnly: true,
                    // headerCheckboxSelection: true,
                },
                {
                    headerName: 'Movement Date',
                    field: 'movement_date',
                    width: 150,
                    checkboxSelection: true,
                    // headerCheckboxSelectionFilteredOnly: true,
                    headerCheckboxSelection: true,
                },
                {
                    headerName: 'Transaction Source',
                    field: 'transaction_source',
                    width: 200,
                },
                {
                    headerName: 'Reference',
                    field: 'gr_reference',
                    width: 100,
                    // pinned: 'left'
                },
                {
                    headerName: 'Client ID',
                    width: 100,
                    field: 'client.client_code'
                },
                {
                    headerName: 'Warehouse ID',
                    field: 'warehouse.name',
                    width: 100,
                },
                {
                    headerName: 'Product ID',
                    field: 'product.product_code',
                    width: 100,
                },
                {
                    headerName: 'Description',
                    field: 'product.description_1',
                    width: 150,
                },
                {
                    headerName: 'Pack ID',
                    field: 'pack_id',
                    width: 150,
                },
                {
                    headerName: 'Batch',
                    field: 'batch',
                    width: 150,
                },
                {
                    headerName: 'Exp. Date',
                    field: 'expired_date',
                    width: 150,
                },
                {
                    headerName: 'Base Qty',
                    field: 'base_qty',
                    width: 100,
                },
                {
                    headerName: 'Base UoM',
                    field: 'base_uom.name',
                    width: 100,
                },
                {
                    headerName: 'Stock Type',
                    field: 'stock_type_id',
                    width: 100,
                },
                {
                    headerName: 'Src. Location Type',
                    field: 'source_location_type.code',
                    width: 100,
                },
                {
                    headerName: 'Src. Location ID',
                    field: 'source_location_id',
                    width: 100,
                },
                {
                    headerName: 'Src. Storage Unit',
                    field: 'source_storage_unit',
                    width: 150,
                },
                {
                    headerName: 'Dest. Location Type',
                    field: 'dest_location_type.code',
                    width: 150,
                },
                {
                    headerName: 'Dest. Location ID',
                    field: 'dest_location_id.location_code',
                    width: 150,
                },
                {
                    headerName: 'Dest. Storage Unit',
                    field: 'destination_storage_unit',
                    width: 150,
                },
                {
                    headerName: 'Status',
                    field: 'mo_statuses.name',
                    width: 200,
                },
            ];
    },	
	methods:{
        exportFileItemLabel(){
			this.labelData = this.inboundItems.map(item => {
				return {
					id: item.id,
					line_id: item.line_id,
					product_code: item.inbound_details.product.product_code,
					product_id: item.inbound_details.product.id,
					uom_id: item.base_uom_id,
					qty: item.base_qty,
					base_qty: item.base_qty,
					uoms: item.uomOption
				}
			})

			this.labelData.map(item => {
				this.setLabelUom(item)
			})

			this.selectedLabel = this.labelData

			this.printLabelPopup = true
        // 	this.isLoading = true
        //    this.$http.get('inbound/goodreceive/report/itemlabeluid/'+this.gr_id, { responseType: 'blob'})
        //   .then(response => {
        //     var blob = new Blob([response.data], {
        //       type: 'application/pdf'
        // 	});
        // 	this.isLoading = false
        //      window.open(URL.createObjectURL(blob));
        //     // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
		//   })
		//   .catch(error => {
		// 	  this.isLoading = false
		// 		var reader = new FileReader()
		// 		const globalThis = this
		// 		reader.onload = function() {
		// 			globalThis.isLoading = false
		// 			const object = JSON.parse(reader.result)
		// 			const message = object.message ? object.message : 'Something went wrong.'

		// 			globalThis.$vs.notify({
		// 				color: 'danger',
		// 				title: 'Error',
		// 				iconPack: 'feather',
		// 				icon:'icon-x',
		// 				text: message
		// 			})
		// 		}
		// 		reader.readAsText(error.response.data)
		//   })
        },
        exportFileGrNote(){
            this.isLoading = true
            this.$http.get('inbound/goodreceive/report/gr_note/'+this.gr_id, { responseType: 'blob'})
            .then(response => {
            var blob = new Blob([response.data], {
                type: 'application/pdf'
            });
                window.open(URL.createObjectURL(blob));
            this.isLoading = false
            // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
            })
            .catch(error => {
                this.isLoading = false
                var reader = new FileReader()
                const globalThis = this
                reader.onload = function() {
                    globalThis.isLoading = false
                    const object = JSON.parse(reader.result)
                    const message = object.message ? object.message : 'Something went wrong.'

                    globalThis.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                }
                reader.readAsText(error.response.data)
            })
        },
        exportFileItemCheck(){
            this.isLoading = true
            this.$http.get('inbound/checkgoodreceive/report/checking_report/'+this.gr_id, { responseType: 'blob'})
            .then(response => {
            this.isLoading = false
            var blob = new Blob([response.data], {
                type: 'application/pdf'
            });
                window.open(URL.createObjectURL(blob));
            // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
            })
            .catch(error => {
                this.isLoading = false
                var reader = new FileReader()
                const globalThis = this
                reader.onload = function() {
                    globalThis.isLoading = false
                    const object = JSON.parse(reader.result)
                    const message = object.message ? object.message : 'Something went wrong.'

                    globalThis.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                }
                reader.readAsText(error.response.data)
            })
        },
        putAwayForeground(){
            this.$router.push({
                name: 'putaway-foreground',
                params: {
                    id: this.gr_id,
                    details: this.inboundItems,
                }
            });
        },
        putAwayBackground(){
            this.$router.push({
                name: 'putaway-background',
                params: {
                    id: this.gr_id,
                }
            });
        },
        cancelGoodReceive(){
            this.isLoading = true
            this.$http.get('inbound/goodreceive/cancel/list/' + this.$route.params.id)
            .then(res => {
                console.log(res.data)
                this.$router.push({
                    name: 'cancel-gr',
                    params: {
                        id: this.gr_id,
                        data: res.data
                    }
                });
            })
            .catch(error => this.handleError(error))
        },
        postGoodReceive(){

            this.isLoading = true ;
                let data_details = [];
                this.inboundItems.map(item => {
                let obj = {
                    id:item.id,
                    };
                data_details.push(obj);
                });


            let data_send = {
            good_receive : JSON.stringify({id:this.gr_id}),
            good_receive_details : JSON.stringify(data_details),
            // inbound_delivery_custom :JSON.stringify(inbound_detail_custom),
            };	
        
            this.$http.post('/inbound/goodreceivedetails/postgoodreceive',data_send)
            .then((resp) => {
                // let rstr = JSON.stringify(resp.data);
                // this.$router.replace('/good-receive');
                this.isLoading = false ;
                this.fetchData()
                this.$vs.notify({
                color: 'success',
                title: 'Post Gr Success',
                text: 'Post Good Receive Succesfully'
                });
            })
            .catch((resp) =>{
                this.isLoading = false ;
                this.$vs.notify({
                color: 'danger',
                title: 'Post Gr Failed',
                text: ''+resp.response.data.message
                });
                console.log(resp.response);
                this.errText = resp.response.data.error;
            });

        },
        itemCheck() {
            this.$router.push({
                name: 'item-check',
                params: {
                    id: this.gr_id
                }
            });
        },
        disabledFullyRecv(data){
            if(data.recv_qty != 0 && data.open_qty == 0 && data.recv_qty == data.base_qty && this.inbound_status.id > 1){
                return true;
            }else{
                return false;
            }
        },
        cancelAndBack(){
            if(this.on_edit){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Leave Page`,
                    text: 'Changes you made may not be saved?',
                    accept: () => {
                            this.$router.replace('/good-receive');
                    }
                    })
            }else{
                this.$router.replace('/good-receive');
            }
        },
        setSelectedProduct(value) {
            if(value != null){
            this.$http.get('/master/product/'+value.product_id.id)
                .then((response) =>  {
                let prd = response.data; 
                    value.description = prd.product.description_1 != null ? prd.product.description_1 : '';
                    value.uomOption = [];
                    value.baseUomOption = [];
                    // for(let i = 0; i < prd.uoms.length; i++){
                    //     this.uomOption.push({...prd.uoms[i].uom, label:prd.uoms[i].uom.name,});
                    // }
                        // console.log("base_uom : "+JSON.stringify(prd.default_uom.uom.name)); 
                        // value.uomOption = prd.uoms;
                        prd.uoms.map(item => {
                            value.uomOption.push(item.uom);
                        })
                        // console.log(JSON.stringify(value.uomOption));
                        value.baseUomOption.push(prd.default_uom.uom);
                        value.uom = prd.default_uom.uom ;
                        value.base_uom = prd.default_uom.uom ;
                })
                .catch(function (error) {
                console.log(error);
                });
                
            }else{
                    this.uom = null;
                    this.uomOption = [];
                    this.base_uom = null;
                    this.baseUomOption = [];
                    this.descriptions = '';
            }
        },
		addItem(){
			this.isLoading = true

			const ds = {
				id: this.inbound_id
			}

			ds.details = this.inboundItems.map(item => {
				if(item.status != 'delete') {
					return {
						inbound_detail_id: item.inbound_details_id,
						qty: item.qty,
						uom_id: item.uom_id
					}
				}
			})

			this.$http.post('/inbound/goodreceive/getremaining', ds)
			.then(res => {
				this.isLoading = false
				res.data.map(item => {
					let exist = false

					this.productOption.map(product => {
						if(product.id == item.product.id) {
							exist = true
						}
                    })

					if(!exist) {
						this.productOption.push(item.product)
					}

					if(item.qty > 0) {
						const uoms = []
						item.product.uoms.map(uom => {
							uom.uom.numerator = uom.numerator
							uom.uom.denominator = uom.denominator
							uoms.push(uom.uom)
						})
						this.inboundItems.push({
							inbound_details_id: item.id,
							uom_id: item.uom_id,
							product_id: item.product,
							line_id: item.line_id,
							description: item.product.description_1,
							pack_id: item.inbound_details.pack_id,
							batch: item.inbound_details.batch,
							expired_date: item.inbound_details.expired_date,
							qty: item.qty,
							check_qty: 0,
							open_qty: item.open_qty,
							base_qty: item.base_qty,
							base_uom: item.base_uom,
							baseUomOption: [item.base_uom],
							uomOption: uoms,
							stock_type_id: this.$store.state.user.userconfig.stock_type_id,
							stockTypeOption: this.inboundItems[0].stockTypeOption,
							status: 'insert',
							uom: item.uom
						})

						this.inboundItems.map(inboundItem => {
							if(inboundItem.open_qty >= 0) {
								inboundItem.open_qty = 0
							}
						})
					}
				})

				this.inboundItems.map(item => {
					this.onChangeUom(item)					
				})

				this.assignLineId()
			})
			.catch(error => {
				this.isLoading = false
				console.log(error)
			})

		//  for (const [index, single] of this.inboundItems.entries()){
		//  	if(single.open_qty > 0){
        // 		let obj = {
		// 		id:single.id,
		// 		inbound_details_id:single.inbound_details_id,
		// 		line_id:this.generateLineId(),
		// 		product_id:single.product_id,
		// 		description:single.description,
		// 		pack_id:'',
		// 		batch:'',
		// 		expired_date:'',
		// 		uom:single.uom,
		// 		qty:single.open_qty,
		// 		base_uom:single.base_uom,
		// 		open_qty:0,
		// 		recv_qty:single.recv_qty,
		// 		base_qty:single.open_qty,
		// 		stock_type_id:single.stock_type_id,
		// 		status:'insert',
		// 		baseUomOption:single.baseUomOption,
		// 		uomOption:single.uomOption,
		// 		stockTypeOption:single.stockTypeOption,
        // 		old_qty:single.open_qty, 
        // 		old_open_qty:single.open_qty, 
        // 		old_base_qty:single.open_qty, 
        // 		old_recv_qty:single.recv_qty, 
        // 		open_qty:0, 
        // 		old_uom_id:single.uom.id,
        // 		first_item_qty:single.first_item_qty,
        // 		errText:'',
        // 		err:false,
        // 		fromIndex:index,
        // 		old_line_id:single.line_id,
        // 	}
        // 	this.inboundItems.push(obj);
        // 	single.open_qty = 0
        // 	single.old_open_qty = single.qty
        // 	single.old_base_qty = single.qty
        // 	single.status = 'update'
        // 	console.log(obj.old_line_id);
        //  	}
        //  }


    ////////////////////////////////////////////////////////////////////////////

            // this.isLoading = true
            // if(this.inboundItems.length <= 0){
            // 	for(let [index, item] of this.oldInboundItems.entries()){
            // 		this.inboundItems.push(item);
            // 		return false ;
            // 	}
            // }else{
                //  for (let [index1, single] of this.inboundItems.entries()){

                //  	let item = this.inboundItems.filter((filter)=>{ //get all gr_item item with gr_details_id
                //  		return filter.id == single.id && filter.status != 'delete'; 
                //  	});

                //  	if (item.length > 0) {

                //  		let count_base_qty = 0
                //  		for (let [index2, single2] of item.entries()){
                //  			count_base_qty += parseInt(single2.base_qty);
                //  		}

                //  		let single3 = this.oldInboundItems.filter((filter)=>{ //get base_qty from old inbound 
                //  			return filter.id == item[0].id
                //  		});

            // 			console.log(single)
            // 			console.log('--- oldInboundItems ---')
            // 			console.log(single3[0])
            // 			// console.log(this.inboundItems[index1].open_qty);
            // 			// console.log('index inbound ' +index1)
                //  		this.inboundItems[index1].open_qty = 0
                //  		this.inboundItems[index1].status = 'update'
                //  		if(count_base_qty < parseInt(single3[0].base_qty)){
                //  			let qty_val =  parseInt(single3[0].base_qty) - count_base_qty
                //  			// this.inboundItems[index1].old_open_qty = qty_val
                //  			this.inboundItems[index1].old_base_qty = parseInt(this.inboundItems[index1].old_base_qty) - qty_val
                //  			console.log(qty_val)
            // 	 			this.inboundItems.push(
                        // 	{
                        // 		id:single.id,
                        // 		inbound_details_id:single.inbound_details_id,
                        // 		line_id:this.generateLineId(),
                        // 		product_id:single.product_id,
                        // 		description:single.description,
                        // 		pack_id:'',
                        // 		batch:'',
                        // 		expired_date:'',
                        // 		uom:single.uom,
                        // 		qty:qty_val,
                        // 		base_uom:single.base_uom,
                        // 		open_qty:0,
                        // 		recv_qty:single.recv_qty,
                        // 		base_qty:qty_val,
                        // 		stock_type_id:single.stock_type_id,
                        // 		status:'insert',
                        // 		baseUomOption:single.baseUomOption,
                        // 		uomOption:single.uomOption,
                        // 		stockTypeOption:single.stockTypeOption,
            //         			old_qty:single.qty, 
            //         			old_open_qty:qty_val, 
            //         			old_base_qty:qty_val, 
            //         			old_recv_qty:single.recv_qty, 
            //         			open_qty:0, 
            //         			old_uom_id:single.uom.id,
                        // 		errText:'',
                        // 		err:false,
                        // 		fromIndex:index1,
                        // 		old_line_id:single.line_id,
                        // 	}
                        // 	);
                //  		}else{
                //  			console.log('tidak nge push')
                //  		}


                //  	}
                //  }
            // }

            // for(let [index, item1] of this.oldInboundItems.entries()){
            // 	let item = this.inboundItems.filter((filter)=>{ //get all inbound item with inbound_details_id
            // 		return filter.id == item1.id ; 
            // 	});
            // 	if(item.length == 0){
            // 		this.inboundItems.push({...item1, open_qty:0});
            // 	}else{
            // 		if(item[0].status == 'delete'){
            // 			item[0].status = 'update';
            // 		}
            // 		// else{
            // 		// 	item[0].status = 'update';
            // 		// }
            // 	}
            // }

            // for(let [index, item1] of this.oldInboundItems.entries()){
            // 	let item = this.inboundItems.filter((filter)=>{ //get all inbound item with inbound_details_id
            // 		return filter.inbound_details_id == item1.inbound_details_id ; 
            // 	});
            // 	if(item.length == 0){
            // 		this.inboundItems.push({...item1});
            // 	}
            // }

        },
        setSelected(value) {
            this.supplier_address_1 = value != null ? value.address_1 : '';
            this.supplier_address_2 = value != null ? value.address_2 : '';
        },
        onChangeClient(value){
            if(value == null){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: `Warning`,
                    text: 'Changing Client ID will be delete All Inbound Items',
                    accept: () => {
                        this.dataItemList= [];
                    }
                    })
            }
        },
        clicked(value){
            let ar = this.dataItemList;
            for(let i=0; i < ar.length; i++) {
                if(ar[i].item_id == value.item_id)
                {
                    ar.splice(i,1);
                }
            }
            this.dataItemList.push(value);
        },
        removeItem(index){
            let length = 0
            this.selected.map(item => {
                if(item.status !== 'delete') {
                    length++
                }
            })

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Warning`,
                text: `Are you sure want to delete ${length} line?`,
                accept: () => {
                    let indexes = []
                    this.selected.map(selected => {
                        this.inboundItems.map((detail, index) => {
                            if(selected.gr_line_id == detail.gr_line_id) {
                                indexes.push(index)
                            }
                        })
                    })

                    this.selected = []

                    indexes.sort((a, b) => b - a)
                    indexes.map(i => {
                        const item = this.inboundItems[i]
                        item.qty = 0
                        if(item.status === 'insert') {
                            this.inboundItems.splice(i, 1)
                        }
                        else {
                            this.inboundItems[i].status = 'delete';
                        }
                    })
                    this.assignLineId()
                }
            })
        },
        onChangeUom(data){
            data.uomOption.map(uom => {
                if(uom.id == data.uom.id) {
                    data.denominator = uom.denominator
                    data.numerator = uom.numerator
                }
            })
            
            // if(data.uom == null){
            // 	data.qty = 0;
            // 	data.base_qty = 0;
            // 	data.open_qty = 0;
            // 	data.uom = null;
            // }
            // if(data.qty > 0){
            // 	let cdata = {
            //         'product_id': data.product_id.id,
            //         'uoms_id': data.uom.id,
            //         'qty': data.qty,
            //       };
            //     // console.log(JSON.stringify(cdata));
            //     this.$http.post('/inbound/conversion', cdata ).then((resp) => {
            //       	// console.log(resp);
            //         this.data_conv = resp.data;
            //         this.validationDetail(data);
            //         // if(this.data_conv > )	
            //     })
            //     .catch((resp) =>{
            //       console.log(resp.response);
            //     });
            // }
        },
        validationDetail(data){

            // if(this.data_conv > data.old_base_qty)
            console.log(data)
            if(this.data_conv > (data.base_qty + data.open_qty)){
                data.errText = 'qty cant higher than open qty';
                data.err = true;
                data.qty = data.old_qty ;
                data.open_qty = data.old_open_qty ;
                data.base_qty = data.old_qty  ;
                data.uom.id = data.old_uom_id;
                console.log('here 1');
            }
            else if(this.data_conv < 0){
                data.open_qty = data.old_base_qty ;
                console.log('here 2')
            }else{
                var sisa = (data.old_base_qty + data.old_open_qty) - this.data_conv
                if(sisa < 0 ){
                    data.errText = 'qty cant higher than open qty';
                    data.err = true;
                    data.qty = data.old_qty ;
                    data.open_qty = data.old_open_qty ;
                    data.base_qty = data.old_qty  ;
                    data.uom.id = data.old_uom_id;
                    console.log('here 3');
                }else{
                    data.open_qty = sisa ;
                    data.base_qty = this.data_conv ; 
                    data.errText = '';
                    data.err = false;
                    data.errText = '';
                    console.log('here 4');
                }
            }
            // console.log("old uom id : "+data.old_uom_id);

        },
        Conversion : function(data){
            let total_qty = data.base_qty + data.open_qty
            let open_qty = 0
            let base_qty = 0
            if(data.qty > 0){
                data.base_qty = (data.qty / data.denominator) * data.numerator
                data.open_qty = total_qty - data.base_qty
                data.err = false;
                data.errText = '';

                open_qty = data.open_qty
                base_qty = data.base_qty
            }else{
                data.base_qty = 0;
                data.open_qty = total_qty
                open_qty = data.open_qty
                base_qty = data.base_qty
                data.err = true;
                data.errText = 'qty must be higer than 0';
            }

            this.inboundItems.map(item => {
                if(data.inbound_details_id == item.inbound_details_id) {
                    item.open_qty = open_qty
                }
            })
        },
        generateLineId(){
            let max_line = 0;
            if(this.inboundItems.length > 0){
                this.inboundItems.map(item => {
                    var tmp = parseInt(item.line_id);
                    if (tmp > max_line){
                        max_line = tmp;
                        // open_qty = parseInt(open_qty);
                    }
                });
            }else{
                return 1 ;
            }
            return max_line+=1;
        },
        editInbound(){
            this.isLoading = true;
            function getProduct(ax) {
                return ax.post('/master/product');
            }	
            function getClient(ax) {
                return ax.post('/master/clients');
            }	         
            function getWarehouse(ax) {
                return ax.post('/master/warehouses');
            }  
            function getOrderTypes(ax) {
                return ax.post('/master/ordertypes');
            }  
            function getSuppliers(ax) {
                return ax.post('/master/customers');
            }  
            function getVehicle(ax) {
                return ax.post('/master/vehicle');
            }
            function getVehicleType(ax) {
                return ax.post('/master/vehicletypes');
            }
            function getTransporter(ax) {
                return ax.post('/master/transporters');
            }          

            if(this.clientOption.length == 0 && this.warehouseOption.length == 0 
                && this.orderTypeOption.length == 0  && this.orderTypeOption.length == 0 
                && this.supplierOption.length == 0){
                this.$http.all([getProduct(this.$http), getClient(this.$http), getWarehouse(this.$http), getOrderTypes(this.$http), getSuppliers(this.$http)])
                    .then(this.$http.spread((product,clients, warehouses, ordertypes, suppliers) => {
                    this.productOption = [];
                    this.clientOption = [];
                    this.warehouseOption = [];
                    this.orderTypeOption =  [];
                    this.supplierOption =  [];
                    this.vehicleOption =  [];
                    this.vehicleTypeOption =  [];
                    this.transporterOption =  [];

                    this.productOption = product.data.data;
                    this.clientOption = clients.data.data;
                    this.warehouseOption = warehouses.data.data;
                    this.orderTypeOption =  ordertypes.data.data;
                    this.supplierOption =  suppliers.data.data;

                    this.getTransportUnloading();

                    this.isLoading = false;

                    }));
            }
            this.on_edit = true;
        },
        getTransportUnloading(){

            function getVehicle(ax) {
                return ax.post('/master/vehicle');
            }
            function getVehicleType(ax) {
                return ax.post('/master/vehicletypes');
            }
            function getTransporter(ax) {
                return ax.post('/master/transporters');
            }          

            if(this.vehicleOption.length == 0 && this.vehicleTypeOption.length == 0 
                && this.transporterOption.length == 0){
                this.$http.all([getVehicle(this.$http), getVehicleType(this.$http), getTransporter(this.$http)])
                    .then(this.$http.spread((vehicles, vehicle_types, transporters) => {

                    this.vehicleOption =  [];
                    this.vehicleTypeOption =  [];
                    this.transporterOption =  [];

                    this.vehicleOption =  vehicles.data.data;
                    this.vehicleTypeOption =  vehicle_types.data.data;
                    this.transporterOption =  transporters.data.data;

                    }));
            }
        },
        handleFileUpload(event){
            this.file = event.target.files[0];
            },
        updateGoodReceive(){
            if(this.gr_reference == '' || this.inbound_reference == '' ||!this.supplier_id || !this.client_id 
            || !this.order_type_id || !this.warehouse_id ){

                this.$vs.notify({
                    color: 'danger',
                    title: 'Error Header ',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Please Check Data Inbound Detail'
                })
                return;
            }

            if(this.inboundItems.length < 1){
                this.$vs.notify({
                    color: 'danger',
                    title: 'Delete Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'At least 1 GR detail needed'
                })
                return;
            }


            for(let detail of this.inboundItems){
                if(detail.status !== 'delete') {
                    if(detail.qty <= 0|| detail.qty == '' || detail.err ) {
    
                        console.log(detail)
    
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error Item Product',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Check Product Line ' + detail.line_id
                        })
                        return;
                    }
                }
            }

            this.isLoading = true ;
            let inbound_head = {
                gr_id:this.gr_id,
                gr_reference:this.gr_reference,
                inbound_reference:this.inbound_reference,
                supplier_id:this.supplier_id,
                client_id:this.client_id,
                order_type_id:this.order_type_id,
                warehouse_id:this.warehouse_id,
                posting_date:this.po_date,
                req_del_date:this.arrival_date,
                remark:this.remark,
            };
            
            let transport_unloading = {
                checker: this.checker,
                supervisor:this.supervisor,
                start_unloading: this.start_unloading,
                end_unloading: this.end_unloading,
                vehicle_id: this.vehicle_id ? this.vehicle_id : null,
                driver: this.driver,
                vehicle_type_id: this.vehicle_type_id ? this.vehicle_type_id : null,
                transporter_id: this.transporter ? this.transporter : null,
                container_number:this.container_number,
                seal_number:this.seal_number, 
            }

                let data_details = [];
                this.inboundItems.map(item => {
                let obj = {
                    id:item.id,
                    gr_id:this.gr_id,
                    inbound_details_id:item.inbound_details_id,
                    inbound_details_line_id:item.inbound_details_line_id,
                    line_id:item.line_id,
                    product_id:item.product_id.id,
                    pack_id:item.inbound_details.pack_id,
                    batch:item.inbound_details.batch,
                    expired_date:item.inbound_details.expired_date,
                    uom_id:item.uom.id,
                    stock_type_id:item.stock_type_id,
                    qty:item.qty,
                    base_uom_id:item.base_uom.id,
                    // open_qty:item.open_qty,
                    recv_qty:item.recv_qty,
                    base_qty:item.base_qty,
                    status:item.qty != item.old_qty && item.status != 'delete' && item.status != 'insert' ? 'update' : item.status,
                    };
                data_details.push(obj);
                });


            let data_send = {
            good_receive : inbound_head,
            good_receive_details : data_details,
            transport_unloading :transport_unloading,
            operators: this.operators
            };	
        
            this.$http.put('/inbound/goodreceive/'+this.gr_id+'/update',data_send)
            .then((resp) => {
                // let rstr = JSON.stringify(resp.data);
                this.on_edit = false;
                this.$router.replace('/good-receive');
                this.$vs.notify({
                color: 'success',
                title: 'Succes',
                text: 'Save Succesfully'
                });
            })
            .catch((resp) => this.handleError(resp));


        },
        viewMo() {
            this.putawayModal = false ;
            this.isLoading = true
            this.$http.post('inventories/movementorder/getbyid', {
                id: this.$route.params.id,
                module: 'good-receive'
            })
            .then(res => {
                this.moModal = true
                this.moList = res.data
            })
            .catch(error => {
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: message
                })
            })
            .then(() => this.isLoading = false)
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
            if (index !== 0) {
                selectedRowsString += ", ";
            }
            selectedRowsString += selectedRow.movement_id;
            });
            this.selectedIdReport = selectedRowsString;
        },
        onSelectionChangedMo() {
            var selectedRows = this.gridApiMo.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
            if (index !== 0) {
                selectedRowsString += ", ";
            }
            selectedRowsString += selectedRow.movement_id;
            });
            this.selectedIdReport = selectedRowsString;
        },
        exportExel(){
            this.isLoading = true
            this.$http.get(this.putawayPrintUrl+this.selectedIdReport, { responseType: 'blob'})
            .then(response => {
                this.isLoading = false
            var blob = new Blob([response.data], {
                type: 'application/pdf'
            });
                window.open(URL.createObjectURL(blob));
            // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
            })
            .catch(error => {
                console.log(error)
                this.isLoading = false
            })
        },
        viewPutaway(url) {
            this.putawayPrintUrl = url ;
            this.isLoading = true
            this.moModal = false ;
            this.$http.get('inbound/goodreceive/report/putawaylist/'+this.$route.params.id)
            .then(res => {
                this.putawayModal = true
                this.moReportList = res.data
            })
            .catch(error => {
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: message
                })
            })
            .then(() => this.isLoading = false)
        },
        confirmData() {
        let selectedData = this.gridApiMo.getSelectedRows()
        console.log(selectedData) ;

        if(selectedData.length <= 0) {
            this.$vs.notify({
                color: 'danger',
                title: 'Error',
                iconPack: 'feather',
                icon:'icon-x',
                text: 'No data selected'
            })
        }
        else {
            this.isLoading = true
            const dataSend = []
            selectedData.map(item => {
                dataSend.push(item.id)
            })
            
            this.$http.post('inventories/movementorder/confirm', {id: dataSend})
            .then(res => {
                this.isLoading = false
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'Confirmed successfully'
                })

                // this.data = {
                //     outbound: {
                //         origin: {
                //             address_1: '',
                //             address_2: ''
                //         },
                //         destination: {
                //             address_1: '',
                //             address_2: ''
                //         },
                //     },
                //     details: [],
                //     status: {
                //         name: ''
                //     },
                //     picked: [],
                //     do_reference: '',
                //     posting_date: null,
                // }

                this.viewMo()
            })
            .catch(error => {
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error saving',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: message
                })
            })
            .then(() => this.isLoading = false)
        }
        // this.viewMo()
    },
    assignLineId() {
        let id = 1
        this.inboundItems.map(item => {
            if(item.status != 'delete') {
                item.gr_line_id = id
                id++
            }
        })
    },
    cancelData() {
        let selectedData = this.gridApiMo.getSelectedRows()
        if(selectedData <= 0) {
            this.$vs.notify({
                color: 'danger',
                title: 'Error',
                iconPack: 'feather',
                icon:'icon-x',
                text: 'No data selected'
            })
        }
        else {
            this.isLoading = true
            const dataSend = []
            selectedData.map(item => {
                dataSend.push({id: item.id})
            })
            
            this.$http.post('putaway/cancelputaway', {'list_putaway': JSON.stringify(dataSend)})
            .then(res => {
                this.isLoading = false
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'Cancelled successfully'
                })

                // this.viewMo()
                // this.data = {
                //     outbound: {
                //         origin: {
                //             address_1: '',
                //             address_2: ''
                //         },
                //         destination: {
                //             address_1: '',
                //             address_2: ''
                //         },
                //     },
                //     details: [],
                //     status: {
                //         name: ''
                //     },
                //     picked: [],
                //     do_reference: '',
                //     posting_date: null,
                // }

                this.viewMo()
            })
            .catch(error => {
                this.isLoading = false
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error saving',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: message
                })
            })
        }
    },
    getDataInbound(id){
            this.$http.get('inbound/inbounddelivery/'+id).then((resp) => {
            let data = resp.data ;

            function getProductbyId(ax, id) {
                return ax.get('master/product/'+id);
            }
            function getStockType(ax) {
                return ax.post('/master/stocktypes');
            }

            data.inbounddetails.map(item => {
                this.productOption.push(item.product);
                this.$http.all([getProductbyId(this.$http, item.product.id), getStockType(this.$http)])
                .then(this.$http.spread((singleProduct, stocktypes) => {
                    let data_uom = [] ;
                    singleProduct.data.uoms.map(uoms => {
                        data_uom.push(uoms.uom);
                    });

                    let obj2 = {...item, status:'exist', description: item.product.description_1, product_id:item.product, 
                        inbound_details_id:item.id, 
                        old_qty:item.qty, 
                        old_open_qty:item.open_qty, 
                        old_base_qty:item.base_qty, 
                        old_recv_qty:item.recv_qty, 
                        open_qty:0, 
                        old_uom_id:item.uom.id,
                        productOption:[item.product], 
                        uomOption:data_uom, 
                        baseUomOption:[item.base_uom], 
                        stockTypeOption:stocktypes.data.data, 
                        stock_type_id:this.$store.state.user.userconfig.stock_type_id,
                        old_line_id:0, 
                        err:false, 
                        errText:''} ;

                    this.oldInboundItems.push(obj2);

                }))
            });

        })
        .catch((resp) =>{
            console.log(resp);
            // if(resp.response.status == 500){
            // } 
        });
    },
    printCheckingList() {
        this.isLoading = true
            this.$http.get('inbound/goodreceive/report/checking_note/'+this.gr_id, { responseType: 'blob'})
            .then(response => {
            var blob = new Blob([response.data], {
                type: 'application/pdf'
            });
                window.open(URL.createObjectURL(blob));
            this.isLoading = false
            // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
            })
            .catch(error => {
                this.isLoading = false
                var reader = new FileReader()
                const globalThis = this
                reader.onload = function() {
                    globalThis.isLoading = false
                    const object = JSON.parse(reader.result)
                    const message = object.message ? object.message : 'Something went wrong.'

                    globalThis.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                }
                reader.readAsText(error.response.data)
            })
    },
        fetchData() {
            this.inboundItems = []
            this.oldInboundItems = []
            this.detailLength = 0
            this.$http.post('unlock_all');
            this.isLoading = true;

            if(this.$route.params.on_edit)
            {
                this.on_edit = true ;
            }
            
            Promise.all([
                this.$http.get('inbound/goodreceive/'+this.$route.params.id),
                this.$http.post('master/stocktypes'),
                this.$http.post('master/operators')
            ])
            .then((res) => {
                const resp = res[0]
                const stocktypes = res[1]
                this.operatorData = res[2].data.data
                this.isLoading = false
                this.stockTypeOption = stocktypes.data.data


                let data = resp.data ;
                let header = data.good_receive ;
                this.operators = this.$_.map(header.operators, 'id');
                // console.log(header.inbound.inbound_reference);
                this.gr_id = header.id ;
                this.gr_reference = header.gr_reference ;
                this.inbound_id = header.inbound.id;
                this.inbound_reference = header.inbound_reference || header.inbound.inbound_reference;
                this.arrival_date = header.req_del_date ||  header.inbound.req_del_date  ;
                this.gr_date = header.gr_date;
                // this.supplier_id = header.supplier_id ;
                this.supplier_address_1 = header.supplier.address_1 ;
                this.supplier_address_2 = header.supplier.address_2 ;
                this.inbound_status = header.status ;
                this.po_date = header.po_date || header.inbound.po_date ;
                this.supplier_id = header.supplier.id;
                this.client_id = header.client.id;
                this.order_type_id = header.order_type.id;
                this.warehouse_id = header.warehouse.id;
                this.remark = header.remark;	
                
                this.client.data.push(header.client)
                this.supplier.data.push(header.supplier)
                this.order_type.data.push(header.order_type)
                this.warehouse.data.push(header.warehouse)

                // this.getTransportUnloading();   
                let transport = data.good_receive_transport;
                
                // this.transporterOption = [transport.transporter]
                // this.vehicleOption = [transport.vehicle_type]
                // this.vehicleOption = [transport.vehicle]
                // custom
                if(transport != null){
                    this.checker = transport.checker
                    this.supervisor = transport.supervisor
                    this.start_unloading = transport.start_unloading
                    this.end_unloading = transport.end_unloading
                    this.vehicle_id = transport.vehicle_id;
                    this.driver = transport.driver
                    this.vehicle_type_id = transport.vehicle_type_id
                    this.transporter = transport.transporter_id
                    this.container_number = transport.container_number
                    this.seal_number = transport.seal_number

                    if(transport.vehicle) {
                        this.vehicle.data.push(transport.vehicle)
                    }

                    if(transport.transporter) {
                        this.transporters.data.push(transport.transporter)
                    }

                    if(transport.vehicle_type) {
                        this.vehicle_type.data.push(transport.vehicle_type)
                    }
                }

                this.productOption = [];

                function getProductbyId(ax, id) {
                    return ax.get('master/product/'+id);
                }
                function getStockType(ax) {
                    return ax.post('/master/stocktypes');
                }

                this.inboundItemsLength = data.good_receive_details.length ;

                data.good_receive_details.map(item => {
                    this.productOption.push(item.inbound_details.product);
                    let data_uom = [] ;
                    item.inbound_details.product.uoms.map(uoms => {
                        uoms.uom.numerator = uoms.numerator
                        uoms.uom.denominator = uoms.denominator
                        data_uom.push(uoms.uom);
                    });
                
                    let obj1 = {...item, status:'exist', description: item.inbound_details.product.description_1, product_id:item.inbound_details.product,
                        inbound_details_id:item.inbound_details_id, 
                        old_qty:item.qty, 
                        old_open_qty:item.open_qty, 
                        old_base_qty:item.base_qty, 
                        old_recv_qty:item.recv_qty,
                        first_item_qty:item.open_qty + item.base_qty, 
                        open_qty:item.open_qty, 
                        old_uom_id:item.uom.id,
                        productOption:[item.inbound_details.product], 
                        uomOption:data_uom, 
                        baseUomOption:[item.base_uom], 
                        stock_type_id:1,
                        old_line_id:0, 
                        err:false, 
                        errText:''} ;

                    let obj2 = {...item, status:'exist', description: item.inbound_details.product.description_1, product_id:item.inbound_details.product, 
                        inbound_details_id:item.inbound_details_id, 
                        old_qty:item.qty, 
                        old_open_qty:item.open_qty, 
                        old_base_qty:item.base_qty, 
                        old_recv_qty:item.recv_qty,
                        first_item_qty:item.open_qty + item.base_qty, 
                        open_qty:item.open_qty, 
                        old_uom_id:item.uom.id,
                        productOption:[item.inbound_details.product], 
                        uomOption:data_uom, 
                        baseUomOption:[item.base_uom], 
                        stock_type_id:1,
                        old_line_id:0, 
                        err:false, 
                        errText:''} ;

                    this.inboundItems.push(obj1);
                    this.oldInboundItems.push(obj2);

                    this.inboundItems.map(item => {
                        this.onChangeUom(item)
                    })

                    this.assignLineId()

                    this.detailLength += 1
                });
        })
        .catch((resp) =>{
            console.log(resp);
            this.cancelAndBack();
            // if(resp.response.status == 500){
            // } 
        });
        },
        printLabel() {
            const data = this.labelData.map(item => {
                return {
                    product_id: item.product_id,
                    qty: item.qty
                }
            })

            if(data.length < 1) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No data selected.'
                })
            }
            else {
                this.isLoading = true
                this.$http.post('inbound/goodreceive/report/print_label', {list: data}, { responseType: 'blob' })
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    
                    window.open(URL.createObjectURL(blob))
                })
                .catch(() => this.isLoading = false)
            }

        },
        setLabelUom(data) {
            data.uoms.map(item => {
                if(data.uom_id == item.id) {
                    data.numerator = item.numerator
                    data.denominator = item.denominator
                }
            })

            data.qty = (data.base_qty / data.denominator) / data.numerator
        },
        removeLabel() {
            let indexes = []
            this.selectedLabel.map(selected => {
                this.labelData.map((detail, index) => {
                    if(selected.id == detail.id) {
                        indexes.push(index)
                    }
                })
            })

            indexes.sort((a, b) => b - a)
            indexes.map(i => this.labelData.splice(i, 1))
            this.selectedLabel = []
        },
        reversePutaway() {
            this.isLoading = true
            this.$http.get('inbound/goodreceive/reverse/list/' + this.$route.params.id)
            .then(res => {
                this.isLoading = false
                this.$router.push({
                    name: 'gr-reverse-putaway',
                    params: {
                        data: res.data,
                        id: this.$route.params.id}
                })
            })
            .catch(error => this.handleError(error))
        },
        reversePutawayList() {
            this.isLoading = true
            this.$http.get('inbound/goodreceive/reverse/report/' + this.$route.params.id, { responseType: 'blob' })
            .then(response => {
                this.isLoading = false
                var blob = new Blob([response.data], {
                    type: 'application/pdf'
                })
                
                window.open(URL.createObjectURL(blob))
            })
            .catch(error => {
                var reader = new FileReader()
                const globalThis = this
                reader.onload = function() {
                    globalThis.isLoading = false
                    const object = JSON.parse(reader.result)
                    const message = object.message ? object.message : 'Something went wrong'

                    globalThis.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                }
                reader.readAsText(error.response.data)
            })
        },
        printItemCheck(){
            this.isLoading = true
            this.$http.get('inbound/goodreceive/report/item_check/'+this.gr_id, { responseType: 'blob'})
            .then(response => {
            var blob = new Blob([response.data], {
                type: 'application/pdf'
            });
                window.open(URL.createObjectURL(blob));
            this.isLoading = false
            // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
            })
            .catch(error => {
                this.isLoading = false
                var reader = new FileReader()
                const globalThis = this
                reader.onload = function() {
                    globalThis.isLoading = false
                    const object = JSON.parse(reader.result)
                    const message = object.message ? object.message : 'Something went wrong.'

                    globalThis.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                }
                reader.readAsText(error.response.data)
            })
        },
        printGrLabel(){
            this.isLoading = true
            this.$http.get('inbound/goodreceive/report/gr_label/'+this.gr_id, { responseType: 'blob'})
            .then(response => {
            var blob = new Blob([response.data], {
                type: 'application/pdf'
            });
                window.open(URL.createObjectURL(blob));
            this.isLoading = false
            // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
            })
            .catch(error => {
                this.isLoading = false
                var reader = new FileReader()
                const globalThis = this
                reader.onload = function() {
                    globalThis.isLoading = false
                    const object = JSON.parse(reader.result)
                    const message = object.message ? object.message : 'Something went wrong.'

                    globalThis.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                }
                reader.readAsText(error.response.data)
            })
        },
    },
    mounted(){
        this.gridApi = this.gridOptions.api;
        this.gridApiMo = this.gridOptionsMo.api;
        
        if(this.$route.params.id != undefined){
            this.fetchData()
            this.$http.get('attachment/'+this.$route.params.id).then((res) => {
            this.attachment = res.data.result
        });
            
        }else{
            this.$router.replace('/good-receive');
        }
    },
	}
</script>

